export const TEAM_STATUS_CHOICES = [
  { value: 'all', label: 'All' },
  { value: 'active', label: 'Active' },
  { value: 'low_engagement', label: 'Low Engagement' },
  { value: 'at_risk', label: 'At Risk' },
  { value: 'dead', label: 'Dead' },
];
